import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  title: {
    color: '#0F0F0F',
    fontFamily: 'Readex Pro',
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: 0.96,
    marginTop: 84,
  },
  textIntroduction: {
    marginTop: 24,
    color: '#404040',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: 0.56,

    '& strong': {
      color: '#404040',
      fontSize: 14,
      fontWeight: '400 !important',
      lineHeight: '20px',
      letterSpacing: 0.56,
    },
  },
  textUnderLine: {
    marginTop: 32,
    color: '#404040',
    fontFamily: 'Readex Pro',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: 0.56,
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
  },
  textTerm: {
    marginTop: 8,
    color: '#404040',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: 0.56,
    textAlign: 'justify',
  },
}));

export default useStyles;
